import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Grid,
  ListItemText,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import { memo, useMemo } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { grey } from '@mui/material/colors';
import { Link } from 'react-router-dom';
import { ROUTE_STRING } from 'constants/RouteString';
import DockerAppTypes from 'constants/DockerAppTypes';
import { formatDateFromISO } from '@tenant/utility/helper/DateHelper';
import { inputFormatDateTime } from '@tenant/utility/constants/default';

const LastRun = ({ lastRun = {}, app = {} }) => {
  const isCronApp = useMemo(
    () =>
      DockerAppTypes.find((e) => e.Value === lastRun.DeploymentType)?.IsCron,
    [lastRun.DeploymentType],
  );

  return (
    <Accordion
      defaultExpanded
      sx={{
        boxShadow: 'none',
        backgroundColor: grey[50],
        pl: 5,
        pr: 5,
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant='h4'> Last Run</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={5}>
          <Grid item xs={12} sm={4}>
            <ListItemText
              primary='Image Name'
              secondary={lastRun.ImageName ?? '-'}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <ListItemText
              primary='Image ID'
              secondary={lastRun.ImageId ?? '-'}
              secondaryTypographyProps={{
                title: lastRun.ImageId,
                sx: {
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                },
              }}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <ListItemText
              primary='Deployment Type'
              secondary={
                DockerAppTypes.find((e) => e.Value === lastRun.DeploymentType)
                  ?.Description || '-'
              }
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <ListItemText
              primary='Repository Url'
              secondary={lastRun.RepositoryUrl ?? '-'}
              secondaryTypographyProps={{
                title: lastRun.RepositoryUrl,
                sx: {
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <ListItemText
              primary='Branch Name'
              secondary={lastRun.BranchName ?? '-'}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <ListItemText
              primary='Dockerfile Path'
              secondary={lastRun.DockerfilePath ?? '-'}
              secondaryTypographyProps={{
                title: lastRun.RepositoryUrl,
                sx: {
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                },
              }}
            />
          </Grid>
          {!isCronApp && (
            <Grid item xs={12} sm={4}>
              <ListItemText
                primary='Target Port'
                secondary={lastRun.TargetPort ?? '-'}
              />
            </Grid>
          )}
          <Grid item xs={12} sm={4}>
            <ListItemText primary='Tag' secondary={lastRun.Tag ?? '-'} />
          </Grid>
          <Grid item xs={12} sm={4}>
            <ListItemText
              primary='Status'
              secondary={
                lastRun.Status ? (
                  <Box
                    component={'span'}
                    color={
                      lastRun.Status === 'Succeeded'
                        ? 'success.main'
                        : lastRun.Status === 'Failed'
                        ? 'error.main'
                        : undefined
                    }
                    size='small'
                    sx={{
                      fontSize: 12,
                      textTransform: 'uppercase',
                    }}
                  >
                    {lastRun.Status}{' '}
                    <Link
                      to={ROUTE_STRING.DOCKER_IMAGE.LOG.replace(
                        ':lastRunId',
                        lastRun.Id,
                      )}
                      color='primary.main'
                      style={{
                        fontSize: 12,
                        textTransform: 'capitalize',
                      }}
                    >
                      (View more)
                    </Link>
                  </Box>
                ) : (
                  '-'
                )
              }
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <ListItemText
              primary='Marketplace App'
              secondary={app?.Name ?? '-'}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <ListItemText
              primary='Created On'
              secondary={
                lastRun.CreatedAt
                  ? formatDateFromISO(lastRun.CreatedAt, inputFormatDateTime)
                  : '-'
              }
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <ListItemText
              primary='Root Folder Path'
              secondary={lastRun.RootFolderPath ?? '-'}
              secondaryTypographyProps={{
                title: lastRun.RootFolderPath,
                sx: {
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                },
              }}
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default memo(LastRun);

LastRun.propTypes = {
  lastRun: PropTypes.object,
  app: PropTypes.object,
};
